var _circle, _circle2, _circle3, _circle4, _ellipse, _path, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _path2, _path3, _path4, _path5, _path6, _path7, _rect, _rect2, _path8, _path9, _path10, _path11, _rect3, _rect4, _path12, _path13, _rect5, _rect6, _rect7, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoIntegrations(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 205,
    height: 205,
    viewBox: "0 0 205 205",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31.549,
    cy: 41.5158,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 180.477,
    cy: 59.1769,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 201.956,
    cy: 68.2462,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 199.569,
    cy: 98.318,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 99.8071,
    cy: 100.347,
    rx: 68.2583,
    ry: 67.6616,
    fill: "#787E8C",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M167.065 100.347C167.065 137.155 136.961 167.009 99.8071 167.009C62.6531 167.009 32.5488 137.155 32.5488 100.347C32.5488 63.539 62.6531 33.6853 99.8071 33.6853C136.961 33.6853 167.065 63.539 167.065 100.347Z",
    stroke: "#787E8C",
    strokeOpacity: 0.8,
    strokeWidth: 2
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.1144,
    cy: 69.6784,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 60.6662,
    cy: 181.851,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 92.1701,
    cy: 192.829,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 149.45,
    cy: 179.942,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 123.196,
    cy: 177.078,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 127.97,
    cy: 190.92,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 109.354,
    cy: 196.648,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 173.794,
    cy: 166.815,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 189.068,
    cy: 138.414,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 179.761,
    cy: 123.616,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 183.579,
    cy: 93.5446,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 191.455,
    cy: 77.3156,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 185.966,
    cy: 40.7998,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 73.3154,
    cy: 199.035,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 39.1865,
    cy: 194.262,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 43.9599,
    cy: 185.908,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 12.9336,
    cy: 147.722,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 19.8545,
    cy: 132.925,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 2.19333,
    cy: 94.4995,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 21.0478,
    cy: 64.6665,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 24.8662,
    cy: 22.4226,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 61.3828,
    cy: 6.19333,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 107.922,
    cy: 24.8093,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 133.936,
    cy: 18.8425,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M169.975 150.347C168.92 150.347 168.065 149.493 168.065 148.438C168.065 147.384 168.92 146.529 169.975 146.529",
    stroke: "#787E8C",
    strokeOpacity: 0.8,
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.01172 117.65C7.06621 117.65 7.92104 116.795 7.92104 115.741C7.92104 114.686 7.06621 113.831 6.01172 113.831",
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0312 22.4226C75.0857 22.4226 75.9406 21.5678 75.9406 20.5133C75.9406 19.4588 75.0857 18.604 74.0312 18.604",
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M120.333 15.7399C119.279 15.7399 118.424 16.5948 118.424 17.6493C118.424 18.7038 119.279 19.5586 120.333 19.5586",
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.83008 166.934H15.7967M25.8207 155.836V157.388M37.5153 166.934H39.0666M25.8207 176.481V178.271M25.8207 180.658V186.982M21.4053 166.934C24.3887 166.934 25.94 162.638 25.94 162.638C25.94 162.638 26.4173 166.934 30.236 166.934C28.5176 166.934 26.0593 168.486 25.8207 171.588C25.8207 171.588 25.5428 169.048 24.6273 168.128C23.863 167.359 21.4053 166.934 21.4053 166.934Z",
    stroke: "#787E8C",
    strokeOpacity: 0.8,
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M178.209 30.0596L172.242 30.0596M162.099 45.8115L162.218 39.6062M150.524 30.0596L148.972 30.0596M162.099 20.7516L162.099 8.57973M166.634 30.0596C163.65 30.0596 162.099 34.3556 162.099 34.3556C162.099 34.3556 161.622 30.0596 157.803 30.0596C159.521 30.0596 161.98 28.5083 162.218 25.4056C162.218 25.4056 162.496 27.9458 163.412 28.8663C164.176 29.6348 166.634 30.0596 166.634 30.0596Z",
    stroke: "#787E8C",
    strokeOpacity: 0.8,
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 98.7373,
    y: 102.027,
    width: 22.3356,
    height: 13.5748,
    rx: 2,
    fill: "white",
    stroke: "#194590",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 98.7373,
    y: 90.3455,
    width: 22.3356,
    height: 10.6545,
    rx: 2,
    fill: "white",
    stroke: "#194590",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 96.6462H26.8356M2.5 106.867H26.8356",
    stroke: "#787E8C",
    strokeWidth: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M173.664 96.6462H198M173.664 106.867H198",
    stroke: "#194590",
    strokeWidth: 2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M104.551 94.2129V96.6464",
    stroke: "#194590",
    strokeWidth: 2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M104.551 107.841V110.274",
    stroke: "#194590",
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 27.3486,
    y: 92.2922,
    width: 11.6279,
    height: 18.4419,
    rx: 2,
    fill: "white",
    stroke: "#787E8C",
    strokeWidth: 2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 39.1533,
    y: 83.9849,
    width: 49.1032,
    height: 36.0303,
    rx: 2,
    fill: "white",
    stroke: "#787E8C",
    strokeWidth: 2
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2061 93.2393V110.274",
    stroke: "#787E8C",
    strokeWidth: 2
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9404 93.2393V110.274",
    stroke: "#787E8C",
    strokeWidth: 2
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 121.156,
    y: 83.9849,
    width: 39.5956,
    height: 36.0303,
    rx: 2,
    fill: "white",
    stroke: "#194590",
    strokeWidth: 2
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 161.036,
    y: 92.2922,
    width: 11.6279,
    height: 18.4419,
    rx: 2,
    fill: "white",
    stroke: "#194590",
    strokeWidth: 2
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 29.4337,
    height: 29.4337,
    transform: "translate(126 87)",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M140.716 114.51C137.298 114.51 134.087 113.178 131.669 110.764C129.252 108.351 127.924 105.135 127.924 101.717C127.924 98.2989 129.256 95.087 131.669 92.6698C134.083 90.2525 137.298 88.9243 140.716 88.9243C144.134 88.9243 147.346 90.2562 149.764 92.6698C152.181 95.0833 153.509 98.2989 153.509 101.717C153.509 105.135 152.177 108.347 149.764 110.764C147.35 113.181 144.134 114.51 140.716 114.51ZM140.716 89.0715C137.339 89.0715 134.164 90.3886 131.776 92.7764C129.388 95.1643 128.071 98.3394 128.071 101.717C128.071 105.094 129.388 108.27 131.776 110.657C134.164 113.045 137.339 114.362 140.716 114.362C144.094 114.362 147.269 113.045 149.657 110.657C152.045 108.27 153.362 105.094 153.362 101.717C153.362 98.3394 152.045 95.1643 149.657 92.7764C147.269 90.3886 144.094 89.0715 140.716 89.0715Z",
    fill: "#194590"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M140.716 111.143C138.2 111.143 135.834 110.164 134.053 108.384C132.273 106.603 131.294 104.237 131.294 101.721C131.294 99.204 132.273 96.8382 134.053 95.0575C135.834 93.2768 138.2 92.2981 140.716 92.2981C143.233 92.2981 145.599 93.2768 147.379 95.0575C149.16 96.8382 150.139 99.204 150.139 101.721C150.139 104.237 149.16 106.603 147.379 108.384C145.599 110.164 143.233 111.143 140.716 111.143ZM140.716 92.4379C138.237 92.4379 135.908 93.4019 134.156 95.1568C132.405 96.9081 131.437 99.2371 131.437 101.717C131.437 104.197 132.401 106.526 134.156 108.277C135.908 110.028 138.237 110.996 140.716 110.996C143.196 110.996 145.525 110.032 147.276 108.277C149.028 106.526 149.995 104.197 149.995 101.717C149.995 99.2371 149.031 96.9081 147.276 95.1568C145.525 93.4055 143.196 92.4379 140.716 92.4379Z",
    fill: "#194590",
    stroke: "#194590"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M140.716 105.37C138.7 105.37 137.062 103.733 137.062 101.717C137.062 99.7007 138.7 98.0635 140.716 98.0635C142.732 98.0635 144.369 99.7007 144.369 101.717C144.369 103.733 142.732 105.37 140.716 105.37ZM140.716 98.2106C138.784 98.2106 137.21 99.7853 137.21 101.717C137.21 103.649 138.784 105.223 140.716 105.223C142.648 105.223 144.222 103.649 144.222 101.717C144.222 99.7853 142.648 98.2106 140.716 98.2106Z",
    fill: "#194590",
    stroke: "#194590"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M146.368 104.009C149.656 104.009 152.321 101.344 152.321 98.0562C152.321 94.7685 149.656 92.1033 146.368 92.1033C143.08 92.1033 140.415 94.7685 140.415 98.0562C140.415 101.344 143.08 104.009 146.368 104.009Z",
    fill: "#194590"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M140.716 114.51C137.298 114.51 134.087 113.178 131.669 110.764C129.252 108.351 127.924 105.135 127.924 101.717C127.924 98.2989 129.256 95.087 131.669 92.6698C134.083 90.2525 137.298 88.9243 140.716 88.9243C144.134 88.9243 147.346 90.2562 149.764 92.6698C152.181 95.0833 153.509 98.2989 153.509 101.717C153.509 105.135 152.177 108.347 149.764 110.764C147.35 113.181 144.134 114.51 140.716 114.51ZM140.716 89.0715C137.339 89.0715 134.164 90.3886 131.776 92.7764C129.388 95.1643 128.071 98.3394 128.071 101.717C128.071 105.094 129.388 108.27 131.776 110.657C134.164 113.045 137.339 114.362 140.716 114.362C144.094 114.362 147.269 113.045 149.657 110.657C152.045 108.27 153.362 105.094 153.362 101.717C153.362 98.3394 152.045 95.1643 149.657 92.7764C147.269 90.3886 144.094 89.0715 140.716 89.0715Z",
    fill: "#194590",
    stroke: "#194590"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M130.252 102.46C129.487 102.46 128.747 102.563 128.041 102.755C128.1 103.465 128.214 104.156 128.383 104.83C128.972 104.646 129.601 104.546 130.252 104.546C133.718 104.546 136.529 107.357 136.529 110.823C136.529 111.78 136.316 112.688 135.929 113.502C136.573 113.763 137.246 113.976 137.938 114.131C138.376 113.115 138.619 112 138.619 110.827C138.615 106.206 134.87 102.46 130.252 102.46Z",
    fill: "#194590"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M150.036 93.0599C149.149 92.107 148.123 91.2902 146.982 90.6463C147.681 91.3601 148.115 92.3351 148.115 93.4131C148.115 95.5949 146.349 97.3609 144.168 97.3609C141.986 97.3609 140.22 95.5949 140.22 93.4131C140.22 91.2387 141.975 89.4763 144.146 89.4653C143.057 89.1599 141.905 88.998 140.72 88.998C140.573 88.998 140.426 89.0017 140.279 89.0054C139.061 90.0834 138.292 91.6581 138.292 93.4131C138.292 96.6618 140.923 99.2925 144.171 99.2925C147.42 99.2925 150.051 96.6618 150.051 93.4131C150.047 93.2954 150.04 93.1776 150.036 93.0599Z",
    fill: "#194590"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M130.371 99.2187C130.084 99.2187 129.815 99.0457 129.701 98.7661C129.628 98.5858 129.631 98.3909 129.709 98.2142C129.786 98.0376 129.926 97.9015 130.102 97.8279C130.47 97.6808 130.893 97.861 131.041 98.229C131.114 98.4092 131.111 98.6042 131.033 98.7808C130.956 98.9574 130.816 99.0936 130.64 99.1672C130.551 99.2003 130.459 99.2187 130.371 99.2187ZM130.367 97.9236C130.297 97.9236 130.224 97.9383 130.154 97.9641C130.01 98.0229 129.9 98.1296 129.841 98.2731C129.782 98.4129 129.779 98.5711 129.838 98.7109C129.955 99.0053 130.29 99.1488 130.584 99.031C130.728 98.9722 130.838 98.8655 130.897 98.722C130.956 98.5822 130.96 98.424 130.901 98.2842C130.813 98.0597 130.595 97.9236 130.367 97.9236Z",
    fill: "#194590"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M151.066 105.676C150.779 105.676 150.511 105.503 150.397 105.223C150.323 105.043 150.327 104.848 150.404 104.671C150.481 104.495 150.621 104.359 150.798 104.285C151.166 104.138 151.589 104.314 151.736 104.686C151.883 105.054 151.707 105.477 151.335 105.624C151.247 105.657 151.155 105.676 151.066 105.676ZM151.063 104.381C150.993 104.381 150.919 104.395 150.849 104.421C150.706 104.48 150.595 104.587 150.537 104.73C150.478 104.87 150.474 105.028 150.533 105.168C150.651 105.462 150.985 105.606 151.28 105.488C151.574 105.37 151.718 105.036 151.6 104.741C151.508 104.517 151.291 104.381 151.063 104.381Z",
    fill: "#194590"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M136.527 97.7726C136.494 97.7726 136.461 97.7726 136.424 97.7689C136.166 97.7431 135.938 97.618 135.776 97.4157C135.614 97.2133 135.541 96.9631 135.567 96.7093C135.592 96.4554 135.717 96.2236 135.92 96.0617C136.332 95.7269 136.943 95.7895 137.277 96.2015C137.439 96.4002 137.513 96.6541 137.487 96.908C137.461 97.1618 137.336 97.3936 137.134 97.5555C136.961 97.6953 136.748 97.7726 136.527 97.7726ZM136.523 95.9882C136.336 95.9882 136.155 96.0507 136.008 96.1721C135.839 96.3082 135.732 96.5069 135.71 96.724C135.688 96.9411 135.751 97.1545 135.887 97.3237C136.023 97.493 136.221 97.5996 136.439 97.6217C136.656 97.6438 136.869 97.5813 137.038 97.4451C137.207 97.309 137.314 97.1103 137.336 96.8932C137.358 96.6762 137.296 96.4628 137.16 96.2935C137.024 96.1243 136.825 96.0176 136.608 95.9955C136.582 95.9918 136.553 95.9882 136.523 95.9882Z",
    fill: "#194590"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M144.654 107.787C144.374 107.787 144.095 107.666 143.903 107.431C143.741 107.232 143.668 106.978 143.694 106.724C143.719 106.47 143.844 106.239 144.047 106.077C144.459 105.742 145.07 105.804 145.404 106.216C145.739 106.629 145.677 107.239 145.265 107.574C145.081 107.718 144.867 107.787 144.654 107.787ZM144.65 106.007C144.47 106.007 144.286 106.066 144.135 106.191C143.785 106.474 143.73 106.989 144.014 107.342C144.297 107.695 144.812 107.747 145.165 107.464C145.515 107.18 145.57 106.665 145.287 106.312C145.125 106.11 144.889 106.007 144.65 106.007Z",
    fill: "#194590"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoIntegrations);
export default __webpack_public_path__ + "static/media/no-integrations.0d6123982afa531532ff935147ba41b6.svg";
export { ForwardRef as ReactComponent };